<template>
    
    <!-- Encabezado de la aplicación -->
    <div class="appHeader no-border transparent position-absolute">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle"></div>
        <div class="right">
        </div>
    </div>
    <!-- * Encabezado de la aplicación -->

    <!-- Cápsula de la aplicación -->
    <div id="appCapsule">

        <div class="section mt-2 text-center">
            <h1>Ingrese el código SMS</h1>
            <h4>Ingrese el código de verificación de 6 dígitos enviado al movil: {{userData.mobile}}</h4>
        </div>
        <div class="section mb-5 p-2">
            <form @submit.prevent="submitForm">
                <div class="form-group basic">
                    <input type="text" class="form-control verification-input" id="smscode" placeholder="••••••" maxlength="6" v-model="code" />
                </div>

                <div class="form-button-group transparent">
                    <button @click="requestSMSAPI" type="button" class="btn btn-secondary btn-block btn-lg">Enviar Codigo</button>
                    <button type="submit" class="btn btn-primary btn-block btn-lg">Verificar</button>
                </div>

            </form>
        </div>

    </div>
    <!-- * Cápsula de la aplicación -->

</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    data() {
        return {
            code: null,
        };
    },
    computed: {
        ...mapState(['userData']),
    },
    methods: {
        ...mapActions(['validateMobileAPI', 'requestSMSAPI']),
        async submitForm() {
            console.log('submitForm', this.code)
            const res = await this.validateMobileAPI(this.code)
            console.log('res', res)
            if (res == true) {
                location.replace("/")
            }
        }
    },
    mounted() {
        let self = this
        self.$root.loadBackButtom();
        if (this.userData.mobile == null) {
            location.replace("/settings/mobile")
        }
        else if (this.userData.validation_mobile == true) {
            location.replace("/")
        }
    }
}
</script>